import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { catchErrorLogRet } from '../../../common/rest.operators';
import { epicDependencies } from '../../../store';
import { Run, RunService } from '../../backend';
import {
    createParamLabelsView,
    createRouterQueryParams,
    parseParamsStr,
} from '../../builder-selection';
import { currentRunState } from '../run.state';

import { layoutRows } from './layout-rows.function';

export function loadRun(runId: string): Observable<Run | null> {
    const runService = epicDependencies.injector.get<RunService>(RunService);

    const state = currentRunState();

    return runService.retrieve(runId).pipe(
        tap((ret) => {
            state.run = ret;

            const bp = parseParamsStr(ret.parameters);

            state.viewParamLabels = createParamLabelsView(bp);

            const parts = layoutRows(ret);
            state.rows = parts[2];
            state.numRows = parts[1].length;

            state.hasCsvArtifact = ret?.results?.[0]?.artifacts?.some(
                (e) => e.mediaType === 'text/csv',
            );

            state.builderQueryParams = createRouterQueryParams(bp);
        }),
        catchErrorLogRet(null),
    );
}
